import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { AirportService } from '../../service/aiport.service';
import { AbstractDataListComponent } from '@app/shared/component/app-data-list/AbstractDataListComponent';
import { KeyValue } from '@app/shared/model/keyValue.model';


@Component({
  selector: 'app-coordinated-airport-data-list',
  templateUrl: './coordinated-airport-data-list.component.html',
  styleUrls: ['./coordinated-airport-data-list.component.scss']/* ,
  changeDetection: ChangeDetectionStrategy.OnPush*/
})
export class CoordinatedAirportDataListComponent extends AbstractDataListComponent implements OnInit, AfterViewInit {
  // ********************** Constructor ***********************************

  @Input() airports: Array<KeyValue>;
  @Input() input: HTMLInputElement;

  public elementsInitial: Array<KeyValue>;

  constructor(
    private airportService: AirportService
  ) {
    super(null, 100);
  }

  ngAfterViewInit(): void {
    if (this.airports) {
      this.elements = this.airports;
    } else {
      try {
        this.searchObservableSubscribe(this.airportService.findAllKeyValues('Coordinated', true), '', () => {
          this.airports = this.elements;
        });
      } catch (error) {
        throw new Error('DataList.component.keySearchData.error');
      }
    }
  }

  keySearchData(key: string): void {
    const filterServices: Array<KeyValue> = [];
    for (const airport of this.airports) {
      if (airport.key.startsWith(key.toUpperCase())) {
        filterServices.push(airport);
      }
    }
    this.elements = filterServices;
  }

  // keySearchData(key: string): void {
  //   console.log('keySearchData');
  //   try {
  //     this.searchObservableSubscribe(this.airportService.findKeyValueByKeyStartingWith(key), key);
  //   } catch (error) {
  //     throw new Error('DataList.component.keySearchData.error');
  //   }
  // }

  valueSearchData(value: string): void {
    const filterServices: Array<KeyValue> = [];
    for (const airport of this.airports) {
      if (airport.value.includes(value.toUpperCase())) {
        filterServices.push(airport);
      }
    }
    this.elements = filterServices;
  }

  public removeDataList(): void {
    this.elements = this.airports;
    if (this.changeDetector) {
      this.changeDetector.detectChanges();
    }
  }

}
